import { FormattedMessage } from 'react-intl';
import Grid from '@material-ui/core/Grid';
import Loader from 'iqvia-shared/components/Loader';
import React, { useEffect } from 'react';

import ErrorModal from '../../../Shared/Modals/ErrorModal';
import PageOneContainer from './PageOneContainer';

export const NoTopicErrorPage = () => (
  <Grid container alignItems="center" justify="center" direction="row">
    <Grid item>
      <FormattedMessage id={`journeyBuilder.decisionSplit_topicFieldErrorMessage`} />
    </Grid>
  </Grid>
);
NoTopicErrorPage.displayName = 'NoTopicErrorPage';

export const JourneyBuilderDecisionSplitFormComponent = ({
  closeErrorWindow,
  errorMessage,
  isDisabledDoneBtn,
  isLoading,
  topicName,
  journeyHasMetadata,
  updateDoneButton,
  translateOutcomes,
}) => {
  useEffect(
    () => {
      if (isDisabledDoneBtn) {
        updateDoneButton(false);
      } else {
        updateDoneButton(true);
      }
    },
    [isDisabledDoneBtn]
  );

  useEffect(
    () => {
      if (!isLoading) {
        translateOutcomes();
      }
    },
    [isLoading]
  );

  return (
    <form noValidate>
      <ErrorModal errorMessage={errorMessage} onClose={closeErrorWindow} open={!!errorMessage} />
      <Grid container>
        <Grid item xs={12}>
          {isLoading ? (
            <Loader />
          ) : journeyHasMetadata && topicName ? (
            <PageOneContainer />
          ) : (
            <NoTopicErrorPage />
          )}
        </Grid>
      </Grid>
    </form>
  );
};

JourneyBuilderDecisionSplitFormComponent.displayName = 'JourneyBuilderForm';

export default JourneyBuilderDecisionSplitFormComponent;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/JourneyBuilderDecisionSplitFormComponent.js